import { useState } from 'react';
import WalkthroughInfoPages from './trial_walkthrough/WalkthroughInfoPages';
import WalkthroughJobSourceSetup from './trial_walkthrough/WalkthroughJobSourceSetup';
import WalkthroughCompletion from './trial_walkthrough/WalkthroughCompletion';

type WalkthroughPhase = 'info' | 'setup' | 'complete';

type Props = {
  onComplete: () => void;
};

export default function TrialWalkthrough({ onComplete }: Props) {
  const [phase, setPhase] = useState<WalkthroughPhase>('info');

  switch (phase) {
    case 'info':
      return <WalkthroughInfoPages onComplete={() => setPhase('setup')} />;
    case 'setup':
      return <WalkthroughJobSourceSetup onComplete={() => setPhase('complete')} />;
    case 'complete':
      return <WalkthroughCompletion onComplete={onComplete} />;
  }
}
